var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{ref:"emoteRoot",attrs:{"as":'span'}},[_c('EmoteItem',{attrs:{"id":_vm.node.attrs.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }